import { render } from "./textTemplate.vue?vue&type=template&id=19248072&scoped=true&ts=true"
import script from "./textTemplate.vue?vue&type=script&lang=ts"
export * from "./textTemplate.vue?vue&type=script&lang=ts"

import "./textTemplate.vue?vue&type=style&index=0&id=19248072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19248072"]])

export default __exports__